<template>
  <div class="mbheader" :class="{color:color}">
    <div class="left" @click="$router.go(-1)" v-if="left">
      <img src="../../assets/img/arrowl.png" alt="">
    </div>
    <div class="min" @click="clickHome">Chinadown</div>
    <div class="min">{{ title }}</div>
    <div class="print" @click="clickPrint">
      <img src="@/assets/img/print.png" alt="">
    </div>
    <div class="navbar-select" v-if="loggedIn">
      <el-select v-model="company_id" :placeholder="$t('pleaseSelect')" @change="changeCompany">
        <el-option
          v-for="item in companyAll"
          :key="item.id"
          :label="item.Name"
          :value="item.id"
          :disabled="company_disabled"
          >
        </el-option>
      </el-select>
    </div>
    <slot></slot>
    <div class="right" v-if="lang" @click="langChanged">
      <img src="../../assets/img/earth2.png" alt="" v-if="$route.name=='account'">
      <img src="../../assets/img/earth.png" alt="" v-else>
    </div>
  </div>
</template>

<script>
import {locales} from "../../mixin";
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex';

export default {
  name: "mbHeader",
  props: ['title', 'color', 'lang', 'left'],
  mixins: [locales],
  data() {
    return {
      //公司的相关数据
      companyAll: [],
      company_id: undefined,
      warehouseAll: [],
      warehouse_id: undefined,
      company_disabled: false
    }
  },
  methods:{
    ...mapActions('products', ['getCompany','getWarehouseByCompany','changeCompanyId','changeWarehouseId']),
    ...mapActions(['changeNavGoId','changeShowProductsType1','changeShowProductsType2','changeShowProductsType3']),
    //更改公司重新查询
    changeCompany(){
      console.log('change公司',this.showProductsType1 ,this.showProductsType2 ,this.showProductsType3);

      if(this.showProductsType1 == 'categories'){
        //选择分组或分类
        return this.$emit('navGo',this.navGoId);
      }
      if(this.showProductsType2 == 'search'){
        //navbar搜索
        return this.$emit('searchProduct');
      }
      if(this.showProductsType3 == 'group'){
        //productList选择分组
        return this.$emit('selectNewGroup',this.navGoId);
      }
    },
    //跳转至Home页
    clickHome(){
      this.$router.push('/home')
    },
    //打印
    async clickPrint(){
      const productListIsLoading = this.$root.getProductListIsLoading()
      if (productListIsLoading) {
        return this.$confirm(this.$t('data_loading_tip'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'error'
        }).then(() => true).catch(() => false)
      }
      await new Promise(resolve => this.$nextTick(resolve))
      const isLoadAll = this.$root.getProductCardImgIsLoad()
      if (!isLoadAll) {
        const isConfirm = await this.$confirm(this.$t('img_loading_tips_text'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          type: 'warning'
        }).then(() => true).catch(() => false)
        // 如果点击的取消
        if (!isConfirm) return
      }
      //没有产品时禁止打印
      if (this.showList && this.showList.length > 0) {
        this.printDisabled = false
      } else {
        this.$confirm(this.$t('you_can_at_print_without_a_product'), this.$t('tips_text'), {
          confirmButtonText: this.$t('confirm_text'),
          cancelButtonText: this.$t('cancel_text'),
          showCancelButton: false,
          showConfirmButton: false,
          type: 'error'
        }).then(() => true).catch(() => false)
        return this.printDisabled = true
      }
      await new Promise(resolve => setTimeout(resolve, 1000))
      //先隐藏
      document.getElementById('navbar').style.display = 'none'
      document.getElementById('banner').style.display = 'none'
      document.getElementById('category-buttons').style.display = 'none'
      document.getElementById('products_div').style.display = 'none'
      document.getElementById('munFooter').style.display = 'none'
      document.getElementById('pcRecommended').style.display = 'none'
      const moreBtn = document.getElementById('product-show-more-button')
      if (moreBtn) {
        moreBtn.style.display = 'none'
      }
      //判断是否登录
      if (this.userInfo.FirstName || this.userInfo.LastName) {
        //添加水印
        setWaterMark('', this.userInfo.FirstName + this.userInfo.LastName)
      }
      //调用打印
      window.print()
      //再显示
      // document.getElementById('navbar').style.display = 'block'
      // document.getElementById('banner').style.display = 'block'
      // document.getElementById('category-buttons').style.display = 'block'
      // document.getElementById('products_div').style.display = 'flex'
      // document.getElementById('munFooter').style.display = 'block'
      // document.getElementById('pcRecommended').style.display = 'block'
      // if (moreBtn) {
      //   moreBtn.style.display = 'block'
      // }
      // if (this.userInfo.FirstName || this.userInfo.LastName) {
        //删除水印
        // removeWatermark()
      // }
    }
  },
  computed: {
      ...mapState({
        loggedIn: state => state.auth.loggedIn,
        companyId: state => state.products.companyId,
        warehouseId: state => state.products.warehouseId,
        userInfo: state => state.auth.userInfo,
        navGoId: state => state.navGoId,
        showProductsType1: state => state.showProductsType1,
        showProductsType2: state => state.showProductsType2,
        showProductsType3: state => state.showProductsType3,
        showList: state => state.showList,
      }),
  },
  created() {
    //默认赋值
    this.company_id=this.companyId;
    //获取所有的公司信息
    this.getCompany()
      .then(res => {
        this.companyAll = res.data;
        if(!this.company_id){
          this.company_id = this.companyAll[0].id;
        }
      }).catch(err => {
      console.log('err brand', err)
    })
  },
  watch: {
    loggedIn: function(newVal, oldVal) {
      immediate: true;
      if (oldVal === true && newVal === false) {
        
      } else if (oldVal === false && newVal === true) {
        
      }
    },
    userInfo: function(newVal, oldVal) {
      immediate: true;
      if(newVal){
        //登录时根据不同的用户显示固定的公司和仓库
        this.companyAll.forEach(item => {
          if(item.id == this.userInfo.Company_id){
            return this.company_id=this.userInfo.Company_id;
          }
        })
        //是否可以修改公司
        this.company_disabled=true;
        if(this.userInfo.is_all_company){
          this.company_disabled=false;
        }
      }
    },
    company_id: function(newVal, oldVal) {
      if (newVal) {
        this.changeCompanyId(this.company_id);
        // console.log('this.company_id',this.company_id);
        //根据公司的id获取仓库
        this.getWarehouseByCompany(this.company_id)
        .then(res => {
          this.warehouseAll = res.data;
          this.warehouseAll.forEach(item => {
            if(item.is_default){
              this.warehouse_id=item.id;
              this.changeWarehouseId(this.warehouse_id);
              // console.log('this.warehouse_id=',this.warehouse_id);
            }
          });
          // console.log('this.warehouseAll=',this.warehouseAll);
        }).catch(err => {
          console.log('err brand', err)
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.mbheader {
  width: 100%;
  height: 50px;
  background-color: #131e1e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 16px 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  &.color {
    background-color: #FFFFFF;

    .min {
      color: black;
    }
  }

  .left, .right {
    height: 30px;
    padding: 5px;
    position: relative;
    z-index: 2;

    img {
      height: 100%;
    }
  }

  .right {
    // margin-left: auto;
  }

  .min {
    color: #FFFFFF;
    text-align: center;
    // position: absolute;
    // left: 0;
    // right: 90px;
    // margin: auto;
    // z-index: 1;
  }
  .print{
    width: 30px;
    height: 30px;
    img{
      width: 100%;
    }
  }

  .navbar-select{
    width: 150px;
  }

  .search-bar {
    position: relative;
    margin-right: 10px;
    flex: 1;

    input {
      width: 100%;
      height: 30px;
      background-color: #FFFFFF;
      border-radius: 15px;
      color: #7cc26a;
      border: none;
      font-size: 12px;
      font-weight: bold;
      box-shadow: none;
      padding: 2px 10px 0;
      font-family: 'Source Sans Pro';
      outline: none;
    }

    .hoverBtn {
      height: 22px;
      width: 22px;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      background-color: #7cc26a;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/mbHeader.vue